// Cart component goes in this file..
import React from 'react';

import '../../../assets/styles/cart-styles/Cart.scss';
// OR
// import '../../../assets/styles/cart-styles/Cart.css';

export default function Cart() {
    return (
        <div>
            <h1>Cart</h1>
        </div>
    )
}
